import CitySEOHead from "@/components/feature/CitySEOHead";
import PalmHarborHeroSection from "./components/HeroSection";
import PalmHarborStickyNav from "./components/StickyNav";
import PalmHarborProcessingTimeSection from "./components/ProcessingTimeSection";
import PalmHarborServicesSection from "./components/ServicesSection";
import PalmHarborLocalAreaSection from "./components/LocalAreaSection";
import PalmHarborTravelTimingSection from "./components/TravelTimingSection";
import PalmHarborDestinationsSection from "./components/DestinationsSection";
import PalmHarborTestimonialsSection from "./components/TestimonialsSection";
import PalmHarborAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PalmHarborComparisonSection from "./components/ComparisonSection";
import PalmHarborMistakesSection from "./components/MistakesSection";
import PalmHarborHowItWorksSection from "./components/HowItWorksSection";
import PalmHarborFAQSection, { faqs } from "./components/FAQSection";
import PalmHarborHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PalmHarborFinalCTA from "./components/FinalCTA";

const palmHarborServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function PalmHarborPage() {
  return (
    <>
      <CitySEOHead
        city="Palm Harbor"
        state="Florida"
        stateAbbr="FL"
        route="/cities/palm-harbor"
        title="Emergency Passport Palm Harbor, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Palm Harbor, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Pinellas County families, golfers, retirees, and Tampa Bay travelers."
        geoPlacename="Palm Harbor, Florida"
        geoPosition="28.0781;-82.7637"
        faqs={faqs}
        servicesSchema={palmHarborServices}
      />
      <div className="font-sans">
        <PalmHarborHeroSection />
        <PalmHarborStickyNav />
        <PalmHarborProcessingTimeSection />
        <PalmHarborServicesSection />
        <PalmHarborLocalAreaSection />
        <PalmHarborTravelTimingSection />
        <PalmHarborDestinationsSection />
        <PalmHarborTestimonialsSection />
        <PalmHarborAcceptanceFacilitiesSection />
        <PalmHarborComparisonSection />
        <PalmHarborMistakesSection />
        <PalmHarborHowItWorksSection />
        <PalmHarborFAQSection />
        <PalmHarborHelpfulResourcesSection />
        <PalmHarborFinalCTA />
      </div>
    </>
  );
}